<template>
    <div class="pt-16 mt-10 flex items-center justify-center bg-gradient-to-br p-6" :class="context.isDarkMode ? 'from-void to-black' : 'from-silver to-white'">
        <div class="rounded-2xl shadow-lg p-8 max-w-md w-full text-center space-y-4" :class="context.isDarkMode ? 'bg-semidark-silver text-silver' : 'bg-white text-void'">
            <img :src="require('@/assets/images/waiting.webp')" alt="Thank you" class="mx-auto w-42 h-42 rounded-2xl" />
            <h1 class="text-2xl font-bold text-gray-800">{{ translationHandler.translate('Thank you') }}, {{ name }}!
            </h1>
            <p class="text-gray-600">
                {{ translationHandler.translate("We've received your information and will get in touch as soon as possible.") }}
            </p>
            <p class="text-sm">
                {{ translationHandler.translate("You'll hear from us via email or phone shortly.") }}
            </p>
            <div 
                class="flex gap-2 content-center primary-button max-width-md grow-effect rounded-3xl px-4 shadow mx-auto mt-10" 
                @click="goHome" 
                :class="context.isDarkMode ? '' : ''"
            >
                <span class="text-lg lg:text-2xl my-auto text-silver font-semibold mx-auto md:mx-0">
                    {{ translationHandler.translate('Back to Homepage', 'capitalize') }}
                </span>
                <i class="text-silver pi pi-objects-column border border-second-color rounded-full bg-second-color p-2 my-auto shadow"></i>
            </div>
        </div>
    </div>
</template>
<script setup>
import DomHandler from '@/composables/handlers/DomHandler';
import translationHandler from '@/composables/handlers/TranslationHandler';
import requestHandler from '@/composables/requestHandler';
import { useContextStore } from '@/stores/context';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const context = useContextStore();
const route = useRoute();
const name = ref();

onMounted(() => {
    name.value = route?.query?.name ?? translationHandler.translate('unknown', 'upper');
    DomHandler.enableScroll();
});

function goHome() {
    return requestHandler.redirect('/');
}

</script>
